module.exports = __webpack_public_path__ + "static/img/product_review.ebffa72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_review.jpg
// module id = rK4h
// module chunks = 0